'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchCountries () {
    return Axios.get('/1.0/countries')
      .then(response => {
        return parseResponse(response).data
      })
      .catch(err => {
        const error = new Error(handleError(err))
        throw error
      })
  }
}
